// Utilities
import Analytics from '../utility/analyticsUtil'
import AppBrowser from '../utility/appBrowserUtil'
import Dialog from '../utility/dialogUtil'
import Logger from '../utility/loggerUtil'

// Libraries
import { mapGetters, mapState } from 'vuex'

export const sidebarMixin = {
  methods: {
    goAppPage (routeName, queryParams = undefined) {
      this.$router.push({ name: routeName, query: queryParams })

      // ConfirmPayment & ConfirmDisbursement manage clearing payment data on exit so don't do it here
      if (!this.$router.currentRoute.name.includes('ConfirmPayment') && !this.$router.currentRoute.name.includes('ConfirmDisbursement')) {
        this.$store.commit('payment/clearPaymentData')
      }
      this.$store.commit('display/toggleSidebar')
    },

    async goExternalPage (url, name, target = '_blank') {
      try {
        Analytics.setScreenName(name)
        const ref = AppBrowser.openInBrowser(url, target)
        return ref
      } catch (e) {
        Logger.error(`Error opening ${url} site link in browser`)
        Logger.debug(e)
        Dialog.errorAlert(this.$t('global.app_browser_error'))
      }
    }
  },

  computed: {
    uploadDocumentNavigationLocation () {
      const baseLocation = !(this.hasCustomerId && this.isTlxeUser) ? 'GuestDocumentVerification' : 'LoanDocumentUpload'
      return `${baseLocation}${this.authenticated ? 'Auth' : 'Unauth'}`
    },

    hasDocumentUploadAccess () {
      return this.displayDocumentUploadMenuItem && ((this.isTlxeUser) || (this.authenticated && !this.hasCustomerId) || !this.authenticated)
    },

    ...mapState('session', ['authenticated', 'displayDocumentUploadMenuItem']),
    ...mapGetters('customer', ['hasCustomerId', 'isTlxeUser'])
  }
}
